module.exports = __webpack_public_path__ + "static/img/4.29170a8a.png";